import { showAlert } from 'utils/ErrorMessage';
import { postGoodAndReturns, getCustomerData, uploadGoodsReturnInfoDetails } from '../../Service/ApiService';
import React, { useState, useEffect } from 'react';
import {
  useNavigate,
  //  useLocation 
} from 'react-router-dom';
import { showSuccessAlert } from 'utils/SuccessMessage';

const GoodAndRetunsController = () => {
  // const location = useLocation();
  const navigate = useNavigate();

  const [searchText, setSearchText] = useState('');

  const [customeroptions, setCustomerOptions] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);

  const [value, setValue] = React.useState('');
  const [goodsReturnsData, setGoodsReturnsData] = useState([]);
  const [deliverySearchError, setDeliverySearchError] = useState('');


  const [openDialog, setOpenDialog] = useState(false);
  const [selectedMaterials, setSelectedMaterials] = useState([]);

  const [loading, setLoading] = useState(false);

  const user = JSON.parse(localStorage.getItem('user'));
  const returnOptions = [
    { label: '1 - Barcode Scan from Loose Than', value: '1' },
    { label: '2 - Pack to Pack Invoice Transfer', value: '2' },
    { label: '3 - Without Barcode', value: '3' },
    { label: '4 - Mixed Quality', value: '4' }
  ];
  // local dropdown state
  const [selectedOption, setSelectedOption] = useState(returnOptions[1]);

  const getEnteredValues = (rawValue) =>
    String(rawValue || '')
      .split(/[\n,]+/)
      .map((item) => item.trim())
      .filter(Boolean);

  const onOptionChange = (e) => {
    setSelectedOption(e);
    // If you want the controller to know about this change, call a handler from controller here:
    // handleOptionChange?.(e.target.value);
  };

  useEffect(() => {
    getCustomer();
  }, [searchText]);

  const getCustomer = async () => {
    if (searchText && searchText.length < 3) {
      return;
    }
    try {

      const response = await getCustomerData(user.userCode, searchText);
      if (response && response.success === 'true') {
        
        const uniqueCustomerOptions = response.customerList.reduce((uniqueList, currentItem) => {
          // Check if the partyCode of the current item is already present in the unique list
          const existingItem = uniqueList.find((item) => item.value === currentItem.partyCode.toString());

          if (!existingItem) {
            uniqueList.push({
              value: currentItem.partyCode.toString(),
              label: currentItem.partyName + '-' + currentItem.city + '-' + currentItem.partyCode.toString()
            });
          }

          return uniqueList;
        }, []);

      
        setCustomerOptions(uniqueCustomerOptions);

       // setSelectedCustomer(null);
      }
    } catch (error) {
      console.error('Error fetching customer data:', error);
    }
  };

  const handleInputChange = (inputValue) => {
    setSearchText(inputValue);
  };



  const getPlaceholder = () => {
    switch (selectedOption.value) {
      case '1':
        return 'Option 1: Scan or paste barcodes (one per line)';
      case '2':
        return 'Option 2: Enter case number(s) or pack info';
      case '3':
        return 'Option 3: Enter quality name / description';
      case '4':
        return 'Option 4: Mixed quality details';
      default:
        return 'Enter details...';
    }
  };

  const handleProceed = () => {
    setDeliverySearchError('');

    if (!selectedOption) {
      showAlert('Please Select Return Option.');
      return;
    }

    if (value.trim() === "") {
      showAlert('Please enter data.');
      return;
    }

    setLoading(true);
    submitData();
  };

  const handleChange = (e) => {
    setValue(e.target.value);
    setDeliverySearchError('');
  };
  const handleTextareaResize = (event) => {
    const textarea = event.target;
    textarea.style.height = 'auto';
  };

  const handleClearButtonClick = () => {
    setValue('');
    setDeliverySearchError('');
  };

  const submitData = async () => {
    try {
      const res = await postGoodAndReturns(user.userCode, selectedOption.value, value);
      if (res && res[0].STATUS === "True" && Array.isArray(res[0].DATA)) {
        const rawList = res[0].DATA;
        const enteredValues = getEnteredValues(value);
        const foundDeliveryNumbers = new Set(
          rawList
            .map((item) => String(item?.DELIVERY_NUMBER || '').trim())
            .filter(Boolean)
        );
        const missingDeliveryNumbers = enteredValues.filter(
          (deliveryNumber) => !foundDeliveryNumbers.has(deliveryNumber)
        );

        // 🔹 Group by DELIVERY_NUMBER + INVOICE_NO
        const groupedMap = {};

        rawList.forEach((item) => {
          const key = `${item.DELIVERY_NUMBER}__${item.INVOICE_NO}`;

          if (!groupedMap[key]) {
            groupedMap[key] = {
              DELIVERY_NUMBER: item.DELIVERY_NUMBER,
              INVOICE_NO: item.INVOICE_NO,
              INVOICE_DATE: item.INVOICE_DATE,
              CUSTOMER_CODE: item.CUSTOMER_CODE,
              materialList: [],
            };
          }

          groupedMap[key].materialList.push(item);
        });

        // Convert object → array
        const groupedRows = Object.values(groupedMap).map((group) => ({
          deliveryNumber: String(group?.DELIVERY_NUMBER || ''),
          invoiceNumber: String(group?.INVOICE_NO || ''),
          invoiceDate: String(group?.INVOICE_DATE || ''),
          customerCode: String(group?.CUSTOMER_CODE || ''),
          materialList: Array.isArray(group?.materialList) ? group.materialList : []
        }));

        setGoodsReturnsData(groupedRows);
        setDeliverySearchError(
          missingDeliveryNumbers.length > 0
            ? `No data found for delivery number: ${missingDeliveryNumbers.join(', ')}`
            : ''
        );
        setLoading(false);
      } else {
        setGoodsReturnsData([]);
        const enteredDeliveryNumber = value.trim();
        const apiMessage = res && res[0] && res[0].MESSAGE ? res[0].MESSAGE : '';
        setDeliverySearchError(apiMessage || `No data found for delivery number: ${enteredDeliveryNumber}`);
        setLoading(false);
      }
    } catch (err) {
      console.error("User Sales Reports load error:", err);
    } finally {
      // setLoading(false);
    }
  };

  const handleTransfer = () => {
    navigate('/good-returns-transfer', { state: { return_option: selectedOption.label.replace(/^\d+\s*-\s*/, '').trim(), order_number: value, goodsReturnsData, party: selectedCustomer } });
  };


  const handleSubmitReturnInfo = async () => {

    if (!selectedCustomer) {
      showAlert('Please Select Customer.');
      return;
    }

    try {
      setLoading(true);

      const payload = {
        return_option: selectedOption.label.replace(/^\d+\s*-\s*/, '').trim(),
        user_code: user.userCode,
        order_number: value || '',
        party_code: selectedCustomer?.value || '',
        from_party_code: goodsReturnsData?.[0]?.CUSTOMER_CODE || '',
        delivery_number: goodsReturnsData?.delivery_number || '',
        invoice_number: goodsReturnsData?.invoice_no || '',
        invoice_date: goodsReturnsData?.invoice_date || '',
        materialInfoDetails: goodsReturnsData || [],
      };

      const res = await uploadGoodsReturnInfoDetails(payload);
      setLoading(false);

      if (res?.success) {
        showSuccessAlert(res.message, 'Message');
        navigate('/good-returns-list');
      } else {
        showAlert(res?.message || 'Failed to submit goods return transfer');
      }
    } catch (err) {
      setLoading(false);
      console.error(err);
    } finally {
      setLoading(false); // 🔹 STOP LOADER
    }
  };

  const handleViewMaterials = (materials) => {


    setSelectedMaterials(materials);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedMaterials([]);
  };


  return {
    handleClearButtonClick,
    selectedOption,
    returnOptions,
    value,
    handleChange,
    handleTextareaResize,
    handleProceed,
    onOptionChange,
    getPlaceholder,
    goodsReturnsData,
    deliverySearchError,
    handleTransfer,

    customeroptions,
    selectedCustomer,
    setSelectedCustomer,
    handleInputChange,

    handleSubmitReturnInfo,

    openDialog,
    selectedMaterials,
    handleViewMaterials,
    handleCloseDialog,

    loading
  };
};

export default GoodAndRetunsController;
